import React from 'react';
import onClickOutside from 'react-onclickoutside';
import { trans } from '../../../../localization';
import { formatDateTimeView, parseToInt } from '../../../../utils/utils';
import { EnumNotificationBell, findEnumById } from '../../../../constants/enum';

export function NotificationItem({
  notification,
  restaurants,
  handleSelectNotification,
  merchantTableInfos,
}) {
  const {
    message,
    orderCode,
    restaurantId,
    createDate,
    type,
    arriveTime,
    isCount,
  } = notification;
  const restaurant = [
    EnumNotificationBell.ORDER.id,
  ].includes(type)
    ? restaurants.find(m => m.restaurant_id === parseToInt(restaurantId))
    : merchantTableInfos.find(m => m.id === parseToInt(restaurantId));
  const { name = trans('restaurant') } = restaurant || {};
  return (
    <li
      onClick={() => handleSelectNotification(restaurant, notification)}
      style={{ backgroundColor: isCount ? '#f1fff6' : '#ffffff' }}
    >
      <img src={findEnumById(EnumNotificationBell, type).logo} alt="mes-logo" />
      <div>
        <span
          className={`title-noti ${findEnumById(EnumNotificationBell, type).className
            }`}
        >
          {findEnumById(EnumNotificationBell, type).title}
        </span>
        <br />
        <span>
          {message} (<strong>{orderCode}</strong>) {trans('from')}{' '}
          <strong>{name}</strong>{' '}
          {type === EnumNotificationBell.TABLE.id && (
            <span>
              {trans('mtn_notification_arrive_time_at')}{' '}
              {formatDateTimeView(arriveTime)}
            </span>
          )}
        </span>
        <br />
        <span style={{ fontSize: '12px', color: '#a2a2a2' }}>
          {formatDateTimeView(createDate)}
        </span>
      </div>
    </li>
  );
}

class NotificationDropdown extends React.PureComponent {
  handleClickOutside = () => {
    const { toggleNotification } = this.props;
    toggleNotification(false);
  };

  render() {
    const {
      notificationBell,
      restaurants,
      handleSelectNotification,
      merchantTableInfos,
    } = this.props;
    const { listNotifications = [] } = notificationBell;
    return (
      <div className="dropdown-notification">
        <ul>
          {listNotifications.map(notification => (
            <NotificationItem
              key={notification.orderCode}
              notification={notification}
              restaurants={restaurants}
              merchantTableInfos={merchantTableInfos}
              handleSelectNotification={handleSelectNotification}
            />
          ))}
        </ul>
      </div>
    );
  }
}

export default onClickOutside(NotificationDropdown);



// WEBPACK FOOTER //
// ./foody/src/layout/components/Header/components/NotificationDropdown.jsx